import { useState, useImperativeHandle, forwardRef, useRef } from 'react';

const SearchBar = forwardRef(({
    initialValue,
    onChange,
    onBlur,
    placeholder,
    size = '',
    disabled = false,
    updateInterval = 200,
    showSpinner = false,
    isLoading = false,
}, ref) => {
    const inputRef = useRef(null);
    const [searchValue, setSearchValue] = useState(initialValue || '');
    const [searchBuffer, setSearchBuffer] = useState();

    useImperativeHandle(ref, () => ({
        resetSearch() {
            setSearchValue('');
        },
        focus() {
            inputRef.current?.focus();
        }
    }));

    return (
        <div className="search-container">
            <input
                ref={inputRef}
                type="search"
                rows={1}
                placeholder={placeholder}
                className={`form-control ${size ? 'form-control-' + size : ''}`}
                value={searchValue}
                onChange={(event) => {
                    clearTimeout(searchBuffer);
                    setSearchValue(event.target.value);
                    setSearchBuffer(setTimeout(() => {
                        if (onChange) {
                            onChange(event.target.value)
                        }
                    }, updateInterval));
                }}
                onBlur={(event) => {
                    if (onBlur) {
                        onBlur(event.target.value)
                    }
                }}
                disabled={disabled}
            />
            {showSpinner && (
                <div className={`spinner-fade ${isLoading? 'loading' : ''}`}>
                    <div className="spinner-border spinner-border-sm text-primary" />
                </div>
            )}
        </div>
    );
})

export default SearchBar;
